import { defineComponent as $, ref as Ce, nextTick as co } from "vue";
import { DateTime as fe, toDate as fo, mergeDateTime as lo, nopList as J, isFunction as fu, nopString as N, isBoolean as ho, nopMap as Yn } from "@afz/base-library";
const po = { year: "2-digit", month: "2-digit", day: "2-digit" }, vo = $({
  name: "CDatetime",
  props: {
    type: {
      type: String,
      default: "date",
      validator: (r) => ["date", "time"].includes(r)
    },
    placement: {
      type: String,
      default: "left"
    },
    placeholder: {
      type: String,
      default: void 0
    },
    format: {
      type: String,
      default: "compact",
      validator: (r) => ["compact", "long"].includes(r)
    },
    min: {
      type: fe,
      default: void 0
    },
    max: {
      type: fe,
      default: void 0
    },
    state: {
      type: Boolean,
      default: null
    },
    dateForTime: {
      type: fe,
      default: void 0
    },
    value: {
      type: fe,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    dateFormat() {
      return this.format === "compact" ? po : void 0;
    },
    inputPlaceholder() {
      return this.placeholder ? this.placeholder : this.type === "date" ? "Seleccione fecha" : "Seleccione hora";
    },
    inputValue() {
      if (!(!this.value || !this.value.isValid))
        return this.type === "date" ? this.value.toISODate() ?? void 0 : this.value.toFormat("HH:mm");
    }
  },
  methods: {
    onInput(r) {
      r.length === 5 && (r = `${r}:00`);
      let e;
      this.type === "date" ? e = fo(r) : e = lo(this.dateForTime, r), this.$emit("input", e);
    }
  }
});
function M(r, e, t, n, a, i, s, u) {
  var o = typeof r == "function" ? r.options : r;
  return e && (o.render = e, o.staticRenderFns = t, o._compiled = !0), i && (o._scopeId = "data-v-" + i), {
    exports: r,
    options: o
  };
}
var _o = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, e.type === "date" ? t("b-form-datepicker", { staticClass: "c-datetime c-datetime--date", attrs: { "date-format-options": e.dateFormat, disabled: e.disabled, left: e.placement === "left", max: e.max?.toJSDate(), min: e.min?.toJSDate(), placeholder: e.inputPlaceholder, right: e.placement === "right", state: e.state, value: e.inputValue }, on: { input: e.onInput } }) : e.type === "time" ? t("b-input-group", [t("b-form-input", { attrs: { disabled: e.disabled, state: e.state, type: "time", value: e.inputValue }, on: { input: e.onInput } }), t("b-input-group-append", [t("b-form-timepicker", { staticClass: "c-datetime c-datetime--time", attrs: { disabled: e.disabled, "button-only": "", "button-variant": "outline-secondary", hour12: !1, left: e.placement === "left", right: e.placement === "right", value: e.inputValue }, on: { input: e.onInput } })], 1)], 1) : e._e();
}, yo = [], bo = /* @__PURE__ */ M(
  vo,
  _o,
  yo,
  !1,
  null,
  null
);
const Nl = bo.exports, go = $({
  name: "CSelect",
  props: {
    service: {
      type: [Promise, Array, Function],
      required: !0
    },
    adapter: {
      type: Function,
      default: void 0
    },
    placeholder: {
      type: String,
      default: void 0
    },
    state: {
      type: Boolean,
      default: null
    },
    value: {
      type: Object,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return { items: J };
  },
  computed: {
    normalizedItems() {
      return !this.adapter || !this.items.length ? this.items : this.items.map(this.adapter);
    },
    inputValue() {
      return this.value ? (this.adapter ? this.adapter(this.value) : this.value).id : void 0;
    }
  },
  watch: {
    service() {
      this.update();
    }
  },
  beforeMount() {
    this.update(!0);
  },
  methods: {
    async update(r = !1) {
      !r && this.value && this.$emit("input", void 0), this.items = (fu(this.service) ? await this.service() : await this.service) ?? J, this.items.length === 1 && this.$emit("input", this.items[0]);
    },
    onInput(r) {
      const e = r ? this.normalizedItems.findIndex((t) => t.id === r) : -1;
      this.$emit("input", this.items[e]);
    }
  }
});
var mo = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("b-form-select", { attrs: { disabled: e.disabled, state: e.state, value: e.inputValue }, on: { input: e.onInput }, scopedSlots: e._u([{ key: "first", fn: function() {
    return [t("b-form-select-option", { attrs: { value: void 0 } }, [e._v(e._s(e.placeholder))])];
  }, proxy: !0 }]) }, e._l(e.normalizedItems, function(n) {
    return t("b-form-select-option", { key: n.id, attrs: { value: n.id } }, [e._v(e._s(n.label))]);
  }), 1);
}, qo = [], Io = /* @__PURE__ */ M(
  go,
  mo,
  qo,
  !1,
  null,
  null
);
const $l = Io.exports, Ro = {
  name: "VueTypeaheadBootstrapListItem",
  props: {
    active: {
      type: Boolean
    },
    data: {},
    screenReaderText: {
      type: String
    },
    htmlText: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    backgroundVariant: {
      type: String
    },
    backgroundVariantResolver: {
      type: Function,
      default: (r) => null,
      validator: (r) => r instanceof Function
    },
    textVariant: {
      type: String
    }
  },
  data: function() {
    return {
      baseTextClasses: ["vbst-item", "list-group-item", "list-group-item-action"]
    };
  },
  computed: {
    textClasses() {
      const r = [...this.baseTextClasses], e = this.backgroundVariantResolver(this.data), t = typeof e == "string" && e.trim() || this.backgroundVariant;
      return t && r.push(`list-group-item-${t}`), this.textVariant && r.push(`text-${this.textVariant}`), this.disabled && r.push("disabled"), r.join(" ");
    }
  },
  methods: {
    processFocusOut(r) {
      const e = r.relatedTarget;
      e && e.classList.contains("vbst-item") || this.$emit("listItemBlur");
    }
  }
};
var Ao = function() {
  var e = this, t = e._self._c;
  return t("a", { class: e.textClasses, attrs: { tabindex: "0", href: "#" }, on: { keydown: [function(n) {
    return !n.type.indexOf("key") && e._k(n.keyCode, "tab", 9, n.key, "Tab") ? null : e.$emit("listItemBlur");
  }, function(n) {
    return !n.type.indexOf("key") && e._k(n.keyCode, "esc", 27, n.key, ["Esc", "Escape"]) ? null : (n.stopPropagation(), n.preventDefault(), e.$emit("listItemBlur"));
  }, function(n) {
    if (!n.type.indexOf("key") && e._k(n.keyCode, "down", 40, n.key, ["Down", "ArrowDown"])) return null;
    n.preventDefault();
  }, function(n) {
    if (!n.type.indexOf("key") && e._k(n.keyCode, "up", 38, n.key, ["Up", "ArrowUp"])) return null;
    n.preventDefault();
  }], keyup: [function(n) {
    return !n.type.indexOf("key") && e._k(n.keyCode, "down", 40, n.key, ["Down", "ArrowDown"]) ? null : e.$parent.selectNextListItem(n);
  }, function(n) {
    return !n.type.indexOf("key") && e._k(n.keyCode, "up", 38, n.key, ["Up", "ArrowUp"]) ? null : e.$parent.selectPreviousListItem(n);
  }], blur: e.processFocusOut } }, [t("div", { staticClass: "sr-only" }, [e._v(e._s(e.screenReaderText))]), t("div", { attrs: { "aria-hidden": "true" } }, [e._t("suggestion", function() {
    return [t("span", { domProps: { innerHTML: e._s(e.htmlText) } })];
  }, null, { data: e.data, htmlText: e.htmlText })], 2)]);
}, To = [], Co = /* @__PURE__ */ M(
  Ro,
  Ao,
  To,
  !1,
  null,
  "e1675009"
);
const So = Co.exports;
var le = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Q(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var Se, Zn;
function Oo() {
  if (Zn) return Se;
  Zn = 1;
  function r() {
    this.__data__ = [], this.size = 0;
  }
  return Se = r, Se;
}
var Oe, ea;
function Mn() {
  if (ea) return Oe;
  ea = 1;
  function r(e, t) {
    return e === t || e !== e && t !== t;
  }
  return Oe = r, Oe;
}
var we, ra;
function ve() {
  if (ra) return we;
  ra = 1;
  var r = Mn();
  function e(t, n) {
    for (var a = t.length; a--; )
      if (r(t[a][0], n))
        return a;
    return -1;
  }
  return we = e, we;
}
var xe, ta;
function wo() {
  if (ta) return xe;
  ta = 1;
  var r = ve(), e = Array.prototype, t = e.splice;
  function n(a) {
    var i = this.__data__, s = r(i, a);
    if (s < 0)
      return !1;
    var u = i.length - 1;
    return s == u ? i.pop() : t.call(i, s, 1), --this.size, !0;
  }
  return xe = n, xe;
}
var Pe, na;
function xo() {
  if (na) return Pe;
  na = 1;
  var r = ve();
  function e(t) {
    var n = this.__data__, a = r(n, t);
    return a < 0 ? void 0 : n[a][1];
  }
  return Pe = e, Pe;
}
var Ee, aa;
function Po() {
  if (aa) return Ee;
  aa = 1;
  var r = ve();
  function e(t) {
    return r(this.__data__, t) > -1;
  }
  return Ee = e, Ee;
}
var Fe, ia;
function Eo() {
  if (ia) return Fe;
  ia = 1;
  var r = ve();
  function e(t, n) {
    var a = this.__data__, i = r(a, t);
    return i < 0 ? (++this.size, a.push([t, n])) : a[i][1] = n, this;
  }
  return Fe = e, Fe;
}
var Me, sa;
function _e() {
  if (sa) return Me;
  sa = 1;
  var r = Oo(), e = wo(), t = xo(), n = Po(), a = Eo();
  function i(s) {
    var u = -1, o = s == null ? 0 : s.length;
    for (this.clear(); ++u < o; ) {
      var c = s[u];
      this.set(c[0], c[1]);
    }
  }
  return i.prototype.clear = r, i.prototype.delete = e, i.prototype.get = t, i.prototype.has = n, i.prototype.set = a, Me = i, Me;
}
var Le, ua;
function Fo() {
  if (ua) return Le;
  ua = 1;
  var r = _e();
  function e() {
    this.__data__ = new r(), this.size = 0;
  }
  return Le = e, Le;
}
var je, oa;
function Mo() {
  if (oa) return je;
  oa = 1;
  function r(e) {
    var t = this.__data__, n = t.delete(e);
    return this.size = t.size, n;
  }
  return je = r, je;
}
var De, ca;
function Lo() {
  if (ca) return De;
  ca = 1;
  function r(e) {
    return this.__data__.get(e);
  }
  return De = r, De;
}
var ke, fa;
function jo() {
  if (fa) return ke;
  fa = 1;
  function r(e) {
    return this.__data__.has(e);
  }
  return ke = r, ke;
}
var Be, la;
function lu() {
  if (la) return Be;
  la = 1;
  var r = typeof le == "object" && le && le.Object === Object && le;
  return Be = r, Be;
}
var Ne, da;
function L() {
  if (da) return Ne;
  da = 1;
  var r = lu(), e = typeof self == "object" && self && self.Object === Object && self, t = r || e || Function("return this")();
  return Ne = t, Ne;
}
var $e, ha;
function ne() {
  if (ha) return $e;
  ha = 1;
  var r = L(), e = r.Symbol;
  return $e = e, $e;
}
var Ge, pa;
function Do() {
  if (pa) return Ge;
  pa = 1;
  var r = ne(), e = Object.prototype, t = e.hasOwnProperty, n = e.toString, a = r ? r.toStringTag : void 0;
  function i(s) {
    var u = t.call(s, a), o = s[a];
    try {
      s[a] = void 0;
      var c = !0;
    } catch {
    }
    var l = n.call(s);
    return c && (u ? s[a] = o : delete s[a]), l;
  }
  return Ge = i, Ge;
}
var Ke, va;
function ko() {
  if (va) return Ke;
  va = 1;
  var r = Object.prototype, e = r.toString;
  function t(n) {
    return e.call(n);
  }
  return Ke = t, Ke;
}
var He, _a;
function Y() {
  if (_a) return He;
  _a = 1;
  var r = ne(), e = Do(), t = ko(), n = "[object Null]", a = "[object Undefined]", i = r ? r.toStringTag : void 0;
  function s(u) {
    return u == null ? u === void 0 ? a : n : i && i in Object(u) ? e(u) : t(u);
  }
  return He = s, He;
}
var Ve, ya;
function G() {
  if (ya) return Ve;
  ya = 1;
  function r(e) {
    var t = typeof e;
    return e != null && (t == "object" || t == "function");
  }
  return Ve = r, Ve;
}
var ze, ba;
function du() {
  if (ba) return ze;
  ba = 1;
  var r = Y(), e = G(), t = "[object AsyncFunction]", n = "[object Function]", a = "[object GeneratorFunction]", i = "[object Proxy]";
  function s(u) {
    if (!e(u))
      return !1;
    var o = r(u);
    return o == n || o == a || o == t || o == i;
  }
  return ze = s, ze;
}
var Ue, ga;
function Bo() {
  if (ga) return Ue;
  ga = 1;
  var r = L(), e = r["__core-js_shared__"];
  return Ue = e, Ue;
}
var We, ma;
function No() {
  if (ma) return We;
  ma = 1;
  var r = Bo(), e = (function() {
    var n = /[^.]+$/.exec(r && r.keys && r.keys.IE_PROTO || "");
    return n ? "Symbol(src)_1." + n : "";
  })();
  function t(n) {
    return !!e && e in n;
  }
  return We = t, We;
}
var Je, qa;
function hu() {
  if (qa) return Je;
  qa = 1;
  var r = Function.prototype, e = r.toString;
  function t(n) {
    if (n != null) {
      try {
        return e.call(n);
      } catch {
      }
      try {
        return n + "";
      } catch {
      }
    }
    return "";
  }
  return Je = t, Je;
}
var Xe, Ia;
function $o() {
  if (Ia) return Xe;
  Ia = 1;
  var r = du(), e = No(), t = G(), n = hu(), a = /[\\^$.*+?()[\]{}|]/g, i = /^\[object .+?Constructor\]$/, s = Function.prototype, u = Object.prototype, o = s.toString, c = u.hasOwnProperty, l = RegExp(
    "^" + o.call(c).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!t(h) || e(h))
      return !1;
    var d = r(h) ? l : i;
    return d.test(n(h));
  }
  return Xe = f, Xe;
}
var Qe, Ra;
function Go() {
  if (Ra) return Qe;
  Ra = 1;
  function r(e, t) {
    return e?.[t];
  }
  return Qe = r, Qe;
}
var Ye, Aa;
function K() {
  if (Aa) return Ye;
  Aa = 1;
  var r = $o(), e = Go();
  function t(n, a) {
    var i = e(n, a);
    return r(i) ? i : void 0;
  }
  return Ye = t, Ye;
}
var Ze, Ta;
function Ln() {
  if (Ta) return Ze;
  Ta = 1;
  var r = K(), e = L(), t = r(e, "Map");
  return Ze = t, Ze;
}
var er, Ca;
function ye() {
  if (Ca) return er;
  Ca = 1;
  var r = K(), e = r(Object, "create");
  return er = e, er;
}
var rr, Sa;
function Ko() {
  if (Sa) return rr;
  Sa = 1;
  var r = ye();
  function e() {
    this.__data__ = r ? r(null) : {}, this.size = 0;
  }
  return rr = e, rr;
}
var tr, Oa;
function Ho() {
  if (Oa) return tr;
  Oa = 1;
  function r(e) {
    var t = this.has(e) && delete this.__data__[e];
    return this.size -= t ? 1 : 0, t;
  }
  return tr = r, tr;
}
var nr, wa;
function Vo() {
  if (wa) return nr;
  wa = 1;
  var r = ye(), e = "__lodash_hash_undefined__", t = Object.prototype, n = t.hasOwnProperty;
  function a(i) {
    var s = this.__data__;
    if (r) {
      var u = s[i];
      return u === e ? void 0 : u;
    }
    return n.call(s, i) ? s[i] : void 0;
  }
  return nr = a, nr;
}
var ar, xa;
function zo() {
  if (xa) return ar;
  xa = 1;
  var r = ye(), e = Object.prototype, t = e.hasOwnProperty;
  function n(a) {
    var i = this.__data__;
    return r ? i[a] !== void 0 : t.call(i, a);
  }
  return ar = n, ar;
}
var ir, Pa;
function Uo() {
  if (Pa) return ir;
  Pa = 1;
  var r = ye(), e = "__lodash_hash_undefined__";
  function t(n, a) {
    var i = this.__data__;
    return this.size += this.has(n) ? 0 : 1, i[n] = r && a === void 0 ? e : a, this;
  }
  return ir = t, ir;
}
var sr, Ea;
function Wo() {
  if (Ea) return sr;
  Ea = 1;
  var r = Ko(), e = Ho(), t = Vo(), n = zo(), a = Uo();
  function i(s) {
    var u = -1, o = s == null ? 0 : s.length;
    for (this.clear(); ++u < o; ) {
      var c = s[u];
      this.set(c[0], c[1]);
    }
  }
  return i.prototype.clear = r, i.prototype.delete = e, i.prototype.get = t, i.prototype.has = n, i.prototype.set = a, sr = i, sr;
}
var ur, Fa;
function Jo() {
  if (Fa) return ur;
  Fa = 1;
  var r = Wo(), e = _e(), t = Ln();
  function n() {
    this.size = 0, this.__data__ = {
      hash: new r(),
      map: new (t || e)(),
      string: new r()
    };
  }
  return ur = n, ur;
}
var or, Ma;
function Xo() {
  if (Ma) return or;
  Ma = 1;
  function r(e) {
    var t = typeof e;
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
  }
  return or = r, or;
}
var cr, La;
function be() {
  if (La) return cr;
  La = 1;
  var r = Xo();
  function e(t, n) {
    var a = t.__data__;
    return r(n) ? a[typeof n == "string" ? "string" : "hash"] : a.map;
  }
  return cr = e, cr;
}
var fr, ja;
function Qo() {
  if (ja) return fr;
  ja = 1;
  var r = be();
  function e(t) {
    var n = r(this, t).delete(t);
    return this.size -= n ? 1 : 0, n;
  }
  return fr = e, fr;
}
var lr, Da;
function Yo() {
  if (Da) return lr;
  Da = 1;
  var r = be();
  function e(t) {
    return r(this, t).get(t);
  }
  return lr = e, lr;
}
var dr, ka;
function Zo() {
  if (ka) return dr;
  ka = 1;
  var r = be();
  function e(t) {
    return r(this, t).has(t);
  }
  return dr = e, dr;
}
var hr, Ba;
function ec() {
  if (Ba) return hr;
  Ba = 1;
  var r = be();
  function e(t, n) {
    var a = r(this, t), i = a.size;
    return a.set(t, n), this.size += a.size == i ? 0 : 1, this;
  }
  return hr = e, hr;
}
var pr, Na;
function jn() {
  if (Na) return pr;
  Na = 1;
  var r = Jo(), e = Qo(), t = Yo(), n = Zo(), a = ec();
  function i(s) {
    var u = -1, o = s == null ? 0 : s.length;
    for (this.clear(); ++u < o; ) {
      var c = s[u];
      this.set(c[0], c[1]);
    }
  }
  return i.prototype.clear = r, i.prototype.delete = e, i.prototype.get = t, i.prototype.has = n, i.prototype.set = a, pr = i, pr;
}
var vr, $a;
function rc() {
  if ($a) return vr;
  $a = 1;
  var r = _e(), e = Ln(), t = jn(), n = 200;
  function a(i, s) {
    var u = this.__data__;
    if (u instanceof r) {
      var o = u.__data__;
      if (!e || o.length < n - 1)
        return o.push([i, s]), this.size = ++u.size, this;
      u = this.__data__ = new t(o);
    }
    return u.set(i, s), this.size = u.size, this;
  }
  return vr = a, vr;
}
var _r, Ga;
function Dn() {
  if (Ga) return _r;
  Ga = 1;
  var r = _e(), e = Fo(), t = Mo(), n = Lo(), a = jo(), i = rc();
  function s(u) {
    var o = this.__data__ = new r(u);
    this.size = o.size;
  }
  return s.prototype.clear = e, s.prototype.delete = t, s.prototype.get = n, s.prototype.has = a, s.prototype.set = i, _r = s, _r;
}
var yr, Ka;
function tc() {
  if (Ka) return yr;
  Ka = 1;
  function r(e, t) {
    for (var n = -1, a = e == null ? 0 : e.length; ++n < a && t(e[n], n, e) !== !1; )
      ;
    return e;
  }
  return yr = r, yr;
}
var br, Ha;
function nc() {
  if (Ha) return br;
  Ha = 1;
  var r = K(), e = (function() {
    try {
      var t = r(Object, "defineProperty");
      return t({}, "", {}), t;
    } catch {
    }
  })();
  return br = e, br;
}
var gr, Va;
function pu() {
  if (Va) return gr;
  Va = 1;
  var r = nc();
  function e(t, n, a) {
    n == "__proto__" && r ? r(t, n, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : t[n] = a;
  }
  return gr = e, gr;
}
var mr, za;
function vu() {
  if (za) return mr;
  za = 1;
  var r = pu(), e = Mn(), t = Object.prototype, n = t.hasOwnProperty;
  function a(i, s, u) {
    var o = i[s];
    (!(n.call(i, s) && e(o, u)) || u === void 0 && !(s in i)) && r(i, s, u);
  }
  return mr = a, mr;
}
var qr, Ua;
function ge() {
  if (Ua) return qr;
  Ua = 1;
  var r = vu(), e = pu();
  function t(n, a, i, s) {
    var u = !i;
    i || (i = {});
    for (var o = -1, c = a.length; ++o < c; ) {
      var l = a[o], f = s ? s(i[l], n[l], l, i, n) : void 0;
      f === void 0 && (f = n[l]), u ? e(i, l, f) : r(i, l, f);
    }
    return i;
  }
  return qr = t, qr;
}
var Ir, Wa;
function ac() {
  if (Wa) return Ir;
  Wa = 1;
  function r(e, t) {
    for (var n = -1, a = Array(e); ++n < e; )
      a[n] = t(n);
    return a;
  }
  return Ir = r, Ir;
}
var Rr, Ja;
function k() {
  if (Ja) return Rr;
  Ja = 1;
  function r(e) {
    return e != null && typeof e == "object";
  }
  return Rr = r, Rr;
}
var Ar, Xa;
function ic() {
  if (Xa) return Ar;
  Xa = 1;
  var r = Y(), e = k(), t = "[object Arguments]";
  function n(a) {
    return e(a) && r(a) == t;
  }
  return Ar = n, Ar;
}
var Tr, Qa;
function kn() {
  if (Qa) return Tr;
  Qa = 1;
  var r = ic(), e = k(), t = Object.prototype, n = t.hasOwnProperty, a = t.propertyIsEnumerable, i = r(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? r : function(s) {
    return e(s) && n.call(s, "callee") && !a.call(s, "callee");
  };
  return Tr = i, Tr;
}
var Cr, Ya;
function F() {
  if (Ya) return Cr;
  Ya = 1;
  var r = Array.isArray;
  return Cr = r, Cr;
}
var ee = { exports: {} }, Sr, Za;
function sc() {
  if (Za) return Sr;
  Za = 1;
  function r() {
    return !1;
  }
  return Sr = r, Sr;
}
ee.exports;
var ei;
function me() {
  return ei || (ei = 1, (function(r, e) {
    var t = L(), n = sc(), a = e && !e.nodeType && e, i = a && !0 && r && !r.nodeType && r, s = i && i.exports === a, u = s ? t.Buffer : void 0, o = u ? u.isBuffer : void 0, c = o || n;
    r.exports = c;
  })(ee, ee.exports)), ee.exports;
}
var Or, ri;
function _u() {
  if (ri) return Or;
  ri = 1;
  var r = 9007199254740991, e = /^(?:0|[1-9]\d*)$/;
  function t(n, a) {
    var i = typeof n;
    return a = a ?? r, !!a && (i == "number" || i != "symbol" && e.test(n)) && n > -1 && n % 1 == 0 && n < a;
  }
  return Or = t, Or;
}
var wr, ti;
function Bn() {
  if (ti) return wr;
  ti = 1;
  var r = 9007199254740991;
  function e(t) {
    return typeof t == "number" && t > -1 && t % 1 == 0 && t <= r;
  }
  return wr = e, wr;
}
var xr, ni;
function uc() {
  if (ni) return xr;
  ni = 1;
  var r = Y(), e = Bn(), t = k(), n = "[object Arguments]", a = "[object Array]", i = "[object Boolean]", s = "[object Date]", u = "[object Error]", o = "[object Function]", c = "[object Map]", l = "[object Number]", f = "[object Object]", h = "[object RegExp]", d = "[object Set]", R = "[object String]", q = "[object WeakMap]", m = "[object ArrayBuffer]", y = "[object DataView]", p = "[object Float32Array]", C = "[object Float64Array]", b = "[object Int8Array]", S = "[object Int16Array]", g = "[object Int32Array]", _ = "[object Uint8Array]", O = "[object Uint8ClampedArray]", A = "[object Uint16Array]", x = "[object Uint32Array]", v = {};
  v[p] = v[C] = v[b] = v[S] = v[g] = v[_] = v[O] = v[A] = v[x] = !0, v[n] = v[a] = v[m] = v[i] = v[y] = v[s] = v[u] = v[o] = v[c] = v[l] = v[f] = v[h] = v[d] = v[R] = v[q] = !1;
  function w(E) {
    return t(E) && e(E.length) && !!v[r(E)];
  }
  return xr = w, xr;
}
var Pr, ai;
function Nn() {
  if (ai) return Pr;
  ai = 1;
  function r(e) {
    return function(t) {
      return e(t);
    };
  }
  return Pr = r, Pr;
}
var re = { exports: {} };
re.exports;
var ii;
function $n() {
  return ii || (ii = 1, (function(r, e) {
    var t = lu(), n = e && !e.nodeType && e, a = n && !0 && r && !r.nodeType && r, i = a && a.exports === n, s = i && t.process, u = (function() {
      try {
        var o = a && a.require && a.require("util").types;
        return o || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    r.exports = u;
  })(re, re.exports)), re.exports;
}
var Er, si;
function Gn() {
  if (si) return Er;
  si = 1;
  var r = uc(), e = Nn(), t = $n(), n = t && t.isTypedArray, a = n ? e(n) : r;
  return Er = a, Er;
}
var Fr, ui;
function yu() {
  if (ui) return Fr;
  ui = 1;
  var r = ac(), e = kn(), t = F(), n = me(), a = _u(), i = Gn(), s = Object.prototype, u = s.hasOwnProperty;
  function o(c, l) {
    var f = t(c), h = !f && e(c), d = !f && !h && n(c), R = !f && !h && !d && i(c), q = f || h || d || R, m = q ? r(c.length, String) : [], y = m.length;
    for (var p in c)
      (l || u.call(c, p)) && !(q && // Safari 9 has enumerable `arguments.length` in strict mode.
      (p == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      d && (p == "offset" || p == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      R && (p == "buffer" || p == "byteLength" || p == "byteOffset") || // Skip index properties.
      a(p, y))) && m.push(p);
    return m;
  }
  return Fr = o, Fr;
}
var Mr, oi;
function qe() {
  if (oi) return Mr;
  oi = 1;
  var r = Object.prototype;
  function e(t) {
    var n = t && t.constructor, a = typeof n == "function" && n.prototype || r;
    return t === a;
  }
  return Mr = e, Mr;
}
var Lr, ci;
function bu() {
  if (ci) return Lr;
  ci = 1;
  function r(e, t) {
    return function(n) {
      return e(t(n));
    };
  }
  return Lr = r, Lr;
}
var jr, fi;
function oc() {
  if (fi) return jr;
  fi = 1;
  var r = bu(), e = r(Object.keys, Object);
  return jr = e, jr;
}
var Dr, li;
function gu() {
  if (li) return Dr;
  li = 1;
  var r = qe(), e = oc(), t = Object.prototype, n = t.hasOwnProperty;
  function a(i) {
    if (!r(i))
      return e(i);
    var s = [];
    for (var u in Object(i))
      n.call(i, u) && u != "constructor" && s.push(u);
    return s;
  }
  return Dr = a, Dr;
}
var kr, di;
function ae() {
  if (di) return kr;
  di = 1;
  var r = du(), e = Bn();
  function t(n) {
    return n != null && e(n.length) && !r(n);
  }
  return kr = t, kr;
}
var Br, hi;
function Z() {
  if (hi) return Br;
  hi = 1;
  var r = yu(), e = gu(), t = ae();
  function n(a) {
    return t(a) ? r(a) : e(a);
  }
  return Br = n, Br;
}
var Nr, pi;
function cc() {
  if (pi) return Nr;
  pi = 1;
  var r = ge(), e = Z();
  function t(n, a) {
    return n && r(a, e(a), n);
  }
  return Nr = t, Nr;
}
var $r, vi;
function fc() {
  if (vi) return $r;
  vi = 1;
  function r(e) {
    var t = [];
    if (e != null)
      for (var n in Object(e))
        t.push(n);
    return t;
  }
  return $r = r, $r;
}
var Gr, _i;
function lc() {
  if (_i) return Gr;
  _i = 1;
  var r = G(), e = qe(), t = fc(), n = Object.prototype, a = n.hasOwnProperty;
  function i(s) {
    if (!r(s))
      return t(s);
    var u = e(s), o = [];
    for (var c in s)
      c == "constructor" && (u || !a.call(s, c)) || o.push(c);
    return o;
  }
  return Gr = i, Gr;
}
var Kr, yi;
function Kn() {
  if (yi) return Kr;
  yi = 1;
  var r = yu(), e = lc(), t = ae();
  function n(a) {
    return t(a) ? r(a, !0) : e(a);
  }
  return Kr = n, Kr;
}
var Hr, bi;
function dc() {
  if (bi) return Hr;
  bi = 1;
  var r = ge(), e = Kn();
  function t(n, a) {
    return n && r(a, e(a), n);
  }
  return Hr = t, Hr;
}
var te = { exports: {} };
te.exports;
var gi;
function hc() {
  return gi || (gi = 1, (function(r, e) {
    var t = L(), n = e && !e.nodeType && e, a = n && !0 && r && !r.nodeType && r, i = a && a.exports === n, s = i ? t.Buffer : void 0, u = s ? s.allocUnsafe : void 0;
    function o(c, l) {
      if (l)
        return c.slice();
      var f = c.length, h = u ? u(f) : new c.constructor(f);
      return c.copy(h), h;
    }
    r.exports = o;
  })(te, te.exports)), te.exports;
}
var Vr, mi;
function pc() {
  if (mi) return Vr;
  mi = 1;
  function r(e, t) {
    var n = -1, a = e.length;
    for (t || (t = Array(a)); ++n < a; )
      t[n] = e[n];
    return t;
  }
  return Vr = r, Vr;
}
var zr, qi;
function mu() {
  if (qi) return zr;
  qi = 1;
  function r(e, t) {
    for (var n = -1, a = e == null ? 0 : e.length, i = 0, s = []; ++n < a; ) {
      var u = e[n];
      t(u, n, e) && (s[i++] = u);
    }
    return s;
  }
  return zr = r, zr;
}
var Ur, Ii;
function qu() {
  if (Ii) return Ur;
  Ii = 1;
  function r() {
    return [];
  }
  return Ur = r, Ur;
}
var Wr, Ri;
function Hn() {
  if (Ri) return Wr;
  Ri = 1;
  var r = mu(), e = qu(), t = Object.prototype, n = t.propertyIsEnumerable, a = Object.getOwnPropertySymbols, i = a ? function(s) {
    return s == null ? [] : (s = Object(s), r(a(s), function(u) {
      return n.call(s, u);
    }));
  } : e;
  return Wr = i, Wr;
}
var Jr, Ai;
function vc() {
  if (Ai) return Jr;
  Ai = 1;
  var r = ge(), e = Hn();
  function t(n, a) {
    return r(n, e(n), a);
  }
  return Jr = t, Jr;
}
var Xr, Ti;
function Iu() {
  if (Ti) return Xr;
  Ti = 1;
  function r(e, t) {
    for (var n = -1, a = t.length, i = e.length; ++n < a; )
      e[i + n] = t[n];
    return e;
  }
  return Xr = r, Xr;
}
var Qr, Ci;
function Ru() {
  if (Ci) return Qr;
  Ci = 1;
  var r = bu(), e = r(Object.getPrototypeOf, Object);
  return Qr = e, Qr;
}
var Yr, Si;
function Au() {
  if (Si) return Yr;
  Si = 1;
  var r = Iu(), e = Ru(), t = Hn(), n = qu(), a = Object.getOwnPropertySymbols, i = a ? function(s) {
    for (var u = []; s; )
      r(u, t(s)), s = e(s);
    return u;
  } : n;
  return Yr = i, Yr;
}
var Zr, Oi;
function _c() {
  if (Oi) return Zr;
  Oi = 1;
  var r = ge(), e = Au();
  function t(n, a) {
    return r(n, e(n), a);
  }
  return Zr = t, Zr;
}
var et, wi;
function Tu() {
  if (wi) return et;
  wi = 1;
  var r = Iu(), e = F();
  function t(n, a, i) {
    var s = a(n);
    return e(n) ? s : r(s, i(n));
  }
  return et = t, et;
}
var rt, xi;
function Cu() {
  if (xi) return rt;
  xi = 1;
  var r = Tu(), e = Hn(), t = Z();
  function n(a) {
    return r(a, t, e);
  }
  return rt = n, rt;
}
var tt, Pi;
function yc() {
  if (Pi) return tt;
  Pi = 1;
  var r = Tu(), e = Au(), t = Kn();
  function n(a) {
    return r(a, t, e);
  }
  return tt = n, tt;
}
var nt, Ei;
function bc() {
  if (Ei) return nt;
  Ei = 1;
  var r = K(), e = L(), t = r(e, "DataView");
  return nt = t, nt;
}
var at, Fi;
function gc() {
  if (Fi) return at;
  Fi = 1;
  var r = K(), e = L(), t = r(e, "Promise");
  return at = t, at;
}
var it, Mi;
function mc() {
  if (Mi) return it;
  Mi = 1;
  var r = K(), e = L(), t = r(e, "Set");
  return it = t, it;
}
var st, Li;
function qc() {
  if (Li) return st;
  Li = 1;
  var r = K(), e = L(), t = r(e, "WeakMap");
  return st = t, st;
}
var ut, ji;
function ie() {
  if (ji) return ut;
  ji = 1;
  var r = bc(), e = Ln(), t = gc(), n = mc(), a = qc(), i = Y(), s = hu(), u = "[object Map]", o = "[object Object]", c = "[object Promise]", l = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", d = s(r), R = s(e), q = s(t), m = s(n), y = s(a), p = i;
  return (r && p(new r(new ArrayBuffer(1))) != h || e && p(new e()) != u || t && p(t.resolve()) != c || n && p(new n()) != l || a && p(new a()) != f) && (p = function(C) {
    var b = i(C), S = b == o ? C.constructor : void 0, g = S ? s(S) : "";
    if (g)
      switch (g) {
        case d:
          return h;
        case R:
          return u;
        case q:
          return c;
        case m:
          return l;
        case y:
          return f;
      }
    return b;
  }), ut = p, ut;
}
var ot, Di;
function Ic() {
  if (Di) return ot;
  Di = 1;
  var r = Object.prototype, e = r.hasOwnProperty;
  function t(n) {
    var a = n.length, i = new n.constructor(a);
    return a && typeof n[0] == "string" && e.call(n, "index") && (i.index = n.index, i.input = n.input), i;
  }
  return ot = t, ot;
}
var ct, ki;
function Su() {
  if (ki) return ct;
  ki = 1;
  var r = L(), e = r.Uint8Array;
  return ct = e, ct;
}
var ft, Bi;
function Vn() {
  if (Bi) return ft;
  Bi = 1;
  var r = Su();
  function e(t) {
    var n = new t.constructor(t.byteLength);
    return new r(n).set(new r(t)), n;
  }
  return ft = e, ft;
}
var lt, Ni;
function Rc() {
  if (Ni) return lt;
  Ni = 1;
  var r = Vn();
  function e(t, n) {
    var a = n ? r(t.buffer) : t.buffer;
    return new t.constructor(a, t.byteOffset, t.byteLength);
  }
  return lt = e, lt;
}
var dt, $i;
function Ac() {
  if ($i) return dt;
  $i = 1;
  var r = /\w*$/;
  function e(t) {
    var n = new t.constructor(t.source, r.exec(t));
    return n.lastIndex = t.lastIndex, n;
  }
  return dt = e, dt;
}
var ht, Gi;
function Tc() {
  if (Gi) return ht;
  Gi = 1;
  var r = ne(), e = r ? r.prototype : void 0, t = e ? e.valueOf : void 0;
  function n(a) {
    return t ? Object(t.call(a)) : {};
  }
  return ht = n, ht;
}
var pt, Ki;
function Cc() {
  if (Ki) return pt;
  Ki = 1;
  var r = Vn();
  function e(t, n) {
    var a = n ? r(t.buffer) : t.buffer;
    return new t.constructor(a, t.byteOffset, t.length);
  }
  return pt = e, pt;
}
var vt, Hi;
function Sc() {
  if (Hi) return vt;
  Hi = 1;
  var r = Vn(), e = Rc(), t = Ac(), n = Tc(), a = Cc(), i = "[object Boolean]", s = "[object Date]", u = "[object Map]", o = "[object Number]", c = "[object RegExp]", l = "[object Set]", f = "[object String]", h = "[object Symbol]", d = "[object ArrayBuffer]", R = "[object DataView]", q = "[object Float32Array]", m = "[object Float64Array]", y = "[object Int8Array]", p = "[object Int16Array]", C = "[object Int32Array]", b = "[object Uint8Array]", S = "[object Uint8ClampedArray]", g = "[object Uint16Array]", _ = "[object Uint32Array]";
  function O(A, x, v) {
    var w = A.constructor;
    switch (x) {
      case d:
        return r(A);
      case i:
      case s:
        return new w(+A);
      case R:
        return e(A, v);
      case q:
      case m:
      case y:
      case p:
      case C:
      case b:
      case S:
      case g:
      case _:
        return a(A, v);
      case u:
        return new w();
      case o:
      case f:
        return new w(A);
      case c:
        return t(A);
      case l:
        return new w();
      case h:
        return n(A);
    }
  }
  return vt = O, vt;
}
var _t, Vi;
function Oc() {
  if (Vi) return _t;
  Vi = 1;
  var r = G(), e = Object.create, t = /* @__PURE__ */ (function() {
    function n() {
    }
    return function(a) {
      if (!r(a))
        return {};
      if (e)
        return e(a);
      n.prototype = a;
      var i = new n();
      return n.prototype = void 0, i;
    };
  })();
  return _t = t, _t;
}
var yt, zi;
function wc() {
  if (zi) return yt;
  zi = 1;
  var r = Oc(), e = Ru(), t = qe();
  function n(a) {
    return typeof a.constructor == "function" && !t(a) ? r(e(a)) : {};
  }
  return yt = n, yt;
}
var bt, Ui;
function xc() {
  if (Ui) return bt;
  Ui = 1;
  var r = ie(), e = k(), t = "[object Map]";
  function n(a) {
    return e(a) && r(a) == t;
  }
  return bt = n, bt;
}
var gt, Wi;
function Pc() {
  if (Wi) return gt;
  Wi = 1;
  var r = xc(), e = Nn(), t = $n(), n = t && t.isMap, a = n ? e(n) : r;
  return gt = a, gt;
}
var mt, Ji;
function Ec() {
  if (Ji) return mt;
  Ji = 1;
  var r = ie(), e = k(), t = "[object Set]";
  function n(a) {
    return e(a) && r(a) == t;
  }
  return mt = n, mt;
}
var qt, Xi;
function Fc() {
  if (Xi) return qt;
  Xi = 1;
  var r = Ec(), e = Nn(), t = $n(), n = t && t.isSet, a = n ? e(n) : r;
  return qt = a, qt;
}
var It, Qi;
function Mc() {
  if (Qi) return It;
  Qi = 1;
  var r = Dn(), e = tc(), t = vu(), n = cc(), a = dc(), i = hc(), s = pc(), u = vc(), o = _c(), c = Cu(), l = yc(), f = ie(), h = Ic(), d = Sc(), R = wc(), q = F(), m = me(), y = Pc(), p = G(), C = Fc(), b = Z(), S = Kn(), g = 1, _ = 2, O = 4, A = "[object Arguments]", x = "[object Array]", v = "[object Boolean]", w = "[object Date]", E = "[object Error]", H = "[object Function]", V = "[object GeneratorFunction]", Te = "[object Map]", Ku = "[object Number]", Un = "[object Object]", Hu = "[object RegExp]", Vu = "[object Set]", zu = "[object String]", Uu = "[object Symbol]", Wu = "[object WeakMap]", Ju = "[object ArrayBuffer]", Xu = "[object DataView]", Qu = "[object Float32Array]", Yu = "[object Float64Array]", Zu = "[object Int8Array]", eo = "[object Int16Array]", ro = "[object Int32Array]", to = "[object Uint8Array]", no = "[object Uint8ClampedArray]", ao = "[object Uint16Array]", io = "[object Uint32Array]", T = {};
  T[A] = T[x] = T[Ju] = T[Xu] = T[v] = T[w] = T[Qu] = T[Yu] = T[Zu] = T[eo] = T[ro] = T[Te] = T[Ku] = T[Un] = T[Hu] = T[Vu] = T[zu] = T[Uu] = T[to] = T[no] = T[ao] = T[io] = !0, T[E] = T[H] = T[Wu] = !1;
  function se(I, z, U, so, ue, j) {
    var P, oe = z & g, ce = z & _, uo = z & O;
    if (U && (P = ue ? U(I, so, ue, j) : U(I)), P !== void 0)
      return P;
    if (!p(I))
      return I;
    var Wn = q(I);
    if (Wn) {
      if (P = h(I), !oe)
        return s(I, P);
    } else {
      var W = f(I), Jn = W == H || W == V;
      if (m(I))
        return i(I, oe);
      if (W == Un || W == A || Jn && !ue) {
        if (P = ce || Jn ? {} : R(I), !oe)
          return ce ? o(I, a(P, I)) : u(I, n(P, I));
      } else {
        if (!T[W])
          return ue ? I : {};
        P = d(I, W, oe);
      }
    }
    j || (j = new r());
    var Xn = j.get(I);
    if (Xn)
      return Xn;
    j.set(I, P), C(I) ? I.forEach(function(D) {
      P.add(se(D, z, U, D, I, j));
    }) : y(I) && I.forEach(function(D, B) {
      P.set(B, se(D, z, U, B, I, j));
    });
    var oo = uo ? ce ? l : c : ce ? S : b, Qn = Wn ? void 0 : oo(I);
    return e(Qn || I, function(D, B) {
      Qn && (B = D, D = I[B]), t(P, B, se(D, z, U, B, I, j));
    }), P;
  }
  return It = se, It;
}
var Rt, Yi;
function Lc() {
  if (Yi) return Rt;
  Yi = 1;
  var r = Mc(), e = 4;
  function t(n) {
    return r(n, e);
  }
  return Rt = t, Rt;
}
var jc = Lc();
const Dc = /* @__PURE__ */ Q(jc);
var At, Zi;
function Ou() {
  if (Zi) return At;
  Zi = 1;
  function r(e, t, n, a) {
    for (var i = e.length, s = n + (a ? 1 : -1); a ? s-- : ++s < i; )
      if (t(e[s], s, e))
        return s;
    return -1;
  }
  return At = r, At;
}
var Tt, es;
function kc() {
  if (es) return Tt;
  es = 1;
  function r(e) {
    return e !== e;
  }
  return Tt = r, Tt;
}
var Ct, rs;
function Bc() {
  if (rs) return Ct;
  rs = 1;
  function r(e, t, n) {
    for (var a = n - 1, i = e.length; ++a < i; )
      if (e[a] === t)
        return a;
    return -1;
  }
  return Ct = r, Ct;
}
var St, ts;
function Nc() {
  if (ts) return St;
  ts = 1;
  var r = Ou(), e = kc(), t = Bc();
  function n(a, i, s) {
    return i === i ? t(a, i, s) : r(a, e, s);
  }
  return St = n, St;
}
var Ot, ns;
function $c() {
  if (ns) return Ot;
  ns = 1;
  var r = Y(), e = F(), t = k(), n = "[object String]";
  function a(i) {
    return typeof i == "string" || !e(i) && t(i) && r(i) == n;
  }
  return Ot = a, Ot;
}
var wt, as;
function Gc() {
  if (as) return wt;
  as = 1;
  var r = /\s/;
  function e(t) {
    for (var n = t.length; n-- && r.test(t.charAt(n)); )
      ;
    return n;
  }
  return wt = e, wt;
}
var xt, is;
function Kc() {
  if (is) return xt;
  is = 1;
  var r = Gc(), e = /^\s+/;
  function t(n) {
    return n && n.slice(0, r(n) + 1).replace(e, "");
  }
  return xt = t, xt;
}
var Pt, ss;
function Ie() {
  if (ss) return Pt;
  ss = 1;
  var r = Y(), e = k(), t = "[object Symbol]";
  function n(a) {
    return typeof a == "symbol" || e(a) && r(a) == t;
  }
  return Pt = n, Pt;
}
var Et, us;
function Hc() {
  if (us) return Et;
  us = 1;
  var r = Kc(), e = G(), t = Ie(), n = NaN, a = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, s = /^0o[0-7]+$/i, u = parseInt;
  function o(c) {
    if (typeof c == "number")
      return c;
    if (t(c))
      return n;
    if (e(c)) {
      var l = typeof c.valueOf == "function" ? c.valueOf() : c;
      c = e(l) ? l + "" : l;
    }
    if (typeof c != "string")
      return c === 0 ? c : +c;
    c = r(c);
    var f = i.test(c);
    return f || s.test(c) ? u(c.slice(2), f ? 2 : 8) : a.test(c) ? n : +c;
  }
  return Et = o, Et;
}
var Ft, os;
function Vc() {
  if (os) return Ft;
  os = 1;
  var r = Hc(), e = 1 / 0, t = 17976931348623157e292;
  function n(a) {
    if (!a)
      return a === 0 ? a : 0;
    if (a = r(a), a === e || a === -e) {
      var i = a < 0 ? -1 : 1;
      return i * t;
    }
    return a === a ? a : 0;
  }
  return Ft = n, Ft;
}
var Mt, cs;
function wu() {
  if (cs) return Mt;
  cs = 1;
  var r = Vc();
  function e(t) {
    var n = r(t), a = n % 1;
    return n === n ? a ? n - a : n : 0;
  }
  return Mt = e, Mt;
}
var Lt, fs;
function xu() {
  if (fs) return Lt;
  fs = 1;
  function r(e, t) {
    for (var n = -1, a = e == null ? 0 : e.length, i = Array(a); ++n < a; )
      i[n] = t(e[n], n, e);
    return i;
  }
  return Lt = r, Lt;
}
var jt, ls;
function zc() {
  if (ls) return jt;
  ls = 1;
  var r = xu();
  function e(t, n) {
    return r(n, function(a) {
      return t[a];
    });
  }
  return jt = e, jt;
}
var Dt, ds;
function Uc() {
  if (ds) return Dt;
  ds = 1;
  var r = zc(), e = Z();
  function t(n) {
    return n == null ? [] : r(n, e(n));
  }
  return Dt = t, Dt;
}
var kt, hs;
function Wc() {
  if (hs) return kt;
  hs = 1;
  var r = Nc(), e = ae(), t = $c(), n = wu(), a = Uc(), i = Math.max;
  function s(u, o, c, l) {
    u = e(u) ? u : a(u), c = c && !l ? n(c) : 0;
    var f = u.length;
    return c < 0 && (c = i(f + c, 0)), t(u) ? c <= f && u.indexOf(o, c) > -1 : !!f && r(u, o, c) > -1;
  }
  return kt = s, kt;
}
var Jc = Wc();
const Xc = /* @__PURE__ */ Q(Jc);
var Bt, ps;
function Qc() {
  if (ps) return Bt;
  ps = 1;
  var r = gu(), e = ie(), t = kn(), n = F(), a = ae(), i = me(), s = qe(), u = Gn(), o = "[object Map]", c = "[object Set]", l = Object.prototype, f = l.hasOwnProperty;
  function h(d) {
    if (d == null)
      return !0;
    if (a(d) && (n(d) || typeof d == "string" || typeof d.splice == "function" || i(d) || u(d) || t(d)))
      return !d.length;
    var R = e(d);
    if (R == o || R == c)
      return !d.size;
    if (s(d))
      return !r(d).length;
    for (var q in d)
      if (f.call(d, q))
        return !1;
    return !0;
  }
  return Bt = h, Bt;
}
var Yc = Qc();
const Zc = /* @__PURE__ */ Q(Yc);
var Nt, vs;
function ef() {
  if (vs) return Nt;
  vs = 1;
  function r(e) {
    return function(t, n, a) {
      for (var i = -1, s = Object(t), u = a(t), o = u.length; o--; ) {
        var c = u[e ? o : ++i];
        if (n(s[c], c, s) === !1)
          break;
      }
      return t;
    };
  }
  return Nt = r, Nt;
}
var $t, _s;
function rf() {
  if (_s) return $t;
  _s = 1;
  var r = ef(), e = r();
  return $t = e, $t;
}
var Gt, ys;
function tf() {
  if (ys) return Gt;
  ys = 1;
  var r = rf(), e = Z();
  function t(n, a) {
    return n && r(n, a, e);
  }
  return Gt = t, Gt;
}
var Kt, bs;
function nf() {
  if (bs) return Kt;
  bs = 1;
  var r = ae();
  function e(t, n) {
    return function(a, i) {
      if (a == null)
        return a;
      if (!r(a))
        return t(a, i);
      for (var s = a.length, u = n ? s : -1, o = Object(a); (n ? u-- : ++u < s) && i(o[u], u, o) !== !1; )
        ;
      return a;
    };
  }
  return Kt = e, Kt;
}
var Ht, gs;
function af() {
  if (gs) return Ht;
  gs = 1;
  var r = tf(), e = nf(), t = e(r);
  return Ht = t, Ht;
}
var Vt, ms;
function sf() {
  if (ms) return Vt;
  ms = 1;
  var r = af();
  function e(t, n) {
    var a = [];
    return r(t, function(i, s, u) {
      n(i, s, u) && a.push(i);
    }), a;
  }
  return Vt = e, Vt;
}
var zt, qs;
function uf() {
  if (qs) return zt;
  qs = 1;
  var r = "__lodash_hash_undefined__";
  function e(t) {
    return this.__data__.set(t, r), this;
  }
  return zt = e, zt;
}
var Ut, Is;
function of() {
  if (Is) return Ut;
  Is = 1;
  function r(e) {
    return this.__data__.has(e);
  }
  return Ut = r, Ut;
}
var Wt, Rs;
function cf() {
  if (Rs) return Wt;
  Rs = 1;
  var r = jn(), e = uf(), t = of();
  function n(a) {
    var i = -1, s = a == null ? 0 : a.length;
    for (this.__data__ = new r(); ++i < s; )
      this.add(a[i]);
  }
  return n.prototype.add = n.prototype.push = e, n.prototype.has = t, Wt = n, Wt;
}
var Jt, As;
function ff() {
  if (As) return Jt;
  As = 1;
  function r(e, t) {
    for (var n = -1, a = e == null ? 0 : e.length; ++n < a; )
      if (t(e[n], n, e))
        return !0;
    return !1;
  }
  return Jt = r, Jt;
}
var Xt, Ts;
function lf() {
  if (Ts) return Xt;
  Ts = 1;
  function r(e, t) {
    return e.has(t);
  }
  return Xt = r, Xt;
}
var Qt, Cs;
function Pu() {
  if (Cs) return Qt;
  Cs = 1;
  var r = cf(), e = ff(), t = lf(), n = 1, a = 2;
  function i(s, u, o, c, l, f) {
    var h = o & n, d = s.length, R = u.length;
    if (d != R && !(h && R > d))
      return !1;
    var q = f.get(s), m = f.get(u);
    if (q && m)
      return q == u && m == s;
    var y = -1, p = !0, C = o & a ? new r() : void 0;
    for (f.set(s, u), f.set(u, s); ++y < d; ) {
      var b = s[y], S = u[y];
      if (c)
        var g = h ? c(S, b, y, u, s, f) : c(b, S, y, s, u, f);
      if (g !== void 0) {
        if (g)
          continue;
        p = !1;
        break;
      }
      if (C) {
        if (!e(u, function(_, O) {
          if (!t(C, O) && (b === _ || l(b, _, o, c, f)))
            return C.push(O);
        })) {
          p = !1;
          break;
        }
      } else if (!(b === S || l(b, S, o, c, f))) {
        p = !1;
        break;
      }
    }
    return f.delete(s), f.delete(u), p;
  }
  return Qt = i, Qt;
}
var Yt, Ss;
function df() {
  if (Ss) return Yt;
  Ss = 1;
  function r(e) {
    var t = -1, n = Array(e.size);
    return e.forEach(function(a, i) {
      n[++t] = [i, a];
    }), n;
  }
  return Yt = r, Yt;
}
var Zt, Os;
function hf() {
  if (Os) return Zt;
  Os = 1;
  function r(e) {
    var t = -1, n = Array(e.size);
    return e.forEach(function(a) {
      n[++t] = a;
    }), n;
  }
  return Zt = r, Zt;
}
var en, ws;
function pf() {
  if (ws) return en;
  ws = 1;
  var r = ne(), e = Su(), t = Mn(), n = Pu(), a = df(), i = hf(), s = 1, u = 2, o = "[object Boolean]", c = "[object Date]", l = "[object Error]", f = "[object Map]", h = "[object Number]", d = "[object RegExp]", R = "[object Set]", q = "[object String]", m = "[object Symbol]", y = "[object ArrayBuffer]", p = "[object DataView]", C = r ? r.prototype : void 0, b = C ? C.valueOf : void 0;
  function S(g, _, O, A, x, v, w) {
    switch (O) {
      case p:
        if (g.byteLength != _.byteLength || g.byteOffset != _.byteOffset)
          return !1;
        g = g.buffer, _ = _.buffer;
      case y:
        return !(g.byteLength != _.byteLength || !v(new e(g), new e(_)));
      case o:
      case c:
      case h:
        return t(+g, +_);
      case l:
        return g.name == _.name && g.message == _.message;
      case d:
      case q:
        return g == _ + "";
      case f:
        var E = a;
      case R:
        var H = A & s;
        if (E || (E = i), g.size != _.size && !H)
          return !1;
        var V = w.get(g);
        if (V)
          return V == _;
        A |= u, w.set(g, _);
        var Te = n(E(g), E(_), A, x, v, w);
        return w.delete(g), Te;
      case m:
        if (b)
          return b.call(g) == b.call(_);
    }
    return !1;
  }
  return en = S, en;
}
var rn, xs;
function vf() {
  if (xs) return rn;
  xs = 1;
  var r = Cu(), e = 1, t = Object.prototype, n = t.hasOwnProperty;
  function a(i, s, u, o, c, l) {
    var f = u & e, h = r(i), d = h.length, R = r(s), q = R.length;
    if (d != q && !f)
      return !1;
    for (var m = d; m--; ) {
      var y = h[m];
      if (!(f ? y in s : n.call(s, y)))
        return !1;
    }
    var p = l.get(i), C = l.get(s);
    if (p && C)
      return p == s && C == i;
    var b = !0;
    l.set(i, s), l.set(s, i);
    for (var S = f; ++m < d; ) {
      y = h[m];
      var g = i[y], _ = s[y];
      if (o)
        var O = f ? o(_, g, y, s, i, l) : o(g, _, y, i, s, l);
      if (!(O === void 0 ? g === _ || c(g, _, u, o, l) : O)) {
        b = !1;
        break;
      }
      S || (S = y == "constructor");
    }
    if (b && !S) {
      var A = i.constructor, x = s.constructor;
      A != x && "constructor" in i && "constructor" in s && !(typeof A == "function" && A instanceof A && typeof x == "function" && x instanceof x) && (b = !1);
    }
    return l.delete(i), l.delete(s), b;
  }
  return rn = a, rn;
}
var tn, Ps;
function _f() {
  if (Ps) return tn;
  Ps = 1;
  var r = Dn(), e = Pu(), t = pf(), n = vf(), a = ie(), i = F(), s = me(), u = Gn(), o = 1, c = "[object Arguments]", l = "[object Array]", f = "[object Object]", h = Object.prototype, d = h.hasOwnProperty;
  function R(q, m, y, p, C, b) {
    var S = i(q), g = i(m), _ = S ? l : a(q), O = g ? l : a(m);
    _ = _ == c ? f : _, O = O == c ? f : O;
    var A = _ == f, x = O == f, v = _ == O;
    if (v && s(q)) {
      if (!s(m))
        return !1;
      S = !0, A = !1;
    }
    if (v && !A)
      return b || (b = new r()), S || u(q) ? e(q, m, y, p, C, b) : t(q, m, _, y, p, C, b);
    if (!(y & o)) {
      var w = A && d.call(q, "__wrapped__"), E = x && d.call(m, "__wrapped__");
      if (w || E) {
        var H = w ? q.value() : q, V = E ? m.value() : m;
        return b || (b = new r()), C(H, V, y, p, b);
      }
    }
    return v ? (b || (b = new r()), n(q, m, y, p, C, b)) : !1;
  }
  return tn = R, tn;
}
var nn, Es;
function Eu() {
  if (Es) return nn;
  Es = 1;
  var r = _f(), e = k();
  function t(n, a, i, s, u) {
    return n === a ? !0 : n == null || a == null || !e(n) && !e(a) ? n !== n && a !== a : r(n, a, i, s, t, u);
  }
  return nn = t, nn;
}
var an, Fs;
function yf() {
  if (Fs) return an;
  Fs = 1;
  var r = Dn(), e = Eu(), t = 1, n = 2;
  function a(i, s, u, o) {
    var c = u.length, l = c, f = !o;
    if (i == null)
      return !l;
    for (i = Object(i); c--; ) {
      var h = u[c];
      if (f && h[2] ? h[1] !== i[h[0]] : !(h[0] in i))
        return !1;
    }
    for (; ++c < l; ) {
      h = u[c];
      var d = h[0], R = i[d], q = h[1];
      if (f && h[2]) {
        if (R === void 0 && !(d in i))
          return !1;
      } else {
        var m = new r();
        if (o)
          var y = o(R, q, d, i, s, m);
        if (!(y === void 0 ? e(q, R, t | n, o, m) : y))
          return !1;
      }
    }
    return !0;
  }
  return an = a, an;
}
var sn, Ms;
function Fu() {
  if (Ms) return sn;
  Ms = 1;
  var r = G();
  function e(t) {
    return t === t && !r(t);
  }
  return sn = e, sn;
}
var un, Ls;
function bf() {
  if (Ls) return un;
  Ls = 1;
  var r = Fu(), e = Z();
  function t(n) {
    for (var a = e(n), i = a.length; i--; ) {
      var s = a[i], u = n[s];
      a[i] = [s, u, r(u)];
    }
    return a;
  }
  return un = t, un;
}
var on, js;
function Mu() {
  if (js) return on;
  js = 1;
  function r(e, t) {
    return function(n) {
      return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
    };
  }
  return on = r, on;
}
var cn, Ds;
function gf() {
  if (Ds) return cn;
  Ds = 1;
  var r = yf(), e = bf(), t = Mu();
  function n(a) {
    var i = e(a);
    return i.length == 1 && i[0][2] ? t(i[0][0], i[0][1]) : function(s) {
      return s === a || r(s, a, i);
    };
  }
  return cn = n, cn;
}
var fn, ks;
function zn() {
  if (ks) return fn;
  ks = 1;
  var r = F(), e = Ie(), t = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, n = /^\w*$/;
  function a(i, s) {
    if (r(i))
      return !1;
    var u = typeof i;
    return u == "number" || u == "symbol" || u == "boolean" || i == null || e(i) ? !0 : n.test(i) || !t.test(i) || s != null && i in Object(s);
  }
  return fn = a, fn;
}
var ln, Bs;
function mf() {
  if (Bs) return ln;
  Bs = 1;
  var r = jn(), e = "Expected a function";
  function t(n, a) {
    if (typeof n != "function" || a != null && typeof a != "function")
      throw new TypeError(e);
    var i = function() {
      var s = arguments, u = a ? a.apply(this, s) : s[0], o = i.cache;
      if (o.has(u))
        return o.get(u);
      var c = n.apply(this, s);
      return i.cache = o.set(u, c) || o, c;
    };
    return i.cache = new (t.Cache || r)(), i;
  }
  return t.Cache = r, ln = t, ln;
}
var dn, Ns;
function qf() {
  if (Ns) return dn;
  Ns = 1;
  var r = mf(), e = 500;
  function t(n) {
    var a = r(n, function(s) {
      return i.size === e && i.clear(), s;
    }), i = a.cache;
    return a;
  }
  return dn = t, dn;
}
var hn, $s;
function If() {
  if ($s) return hn;
  $s = 1;
  var r = qf(), e = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, t = /\\(\\)?/g, n = r(function(a) {
    var i = [];
    return a.charCodeAt(0) === 46 && i.push(""), a.replace(e, function(s, u, o, c) {
      i.push(o ? c.replace(t, "$1") : u || s);
    }), i;
  });
  return hn = n, hn;
}
var pn, Gs;
function Rf() {
  if (Gs) return pn;
  Gs = 1;
  var r = ne(), e = xu(), t = F(), n = Ie(), a = r ? r.prototype : void 0, i = a ? a.toString : void 0;
  function s(u) {
    if (typeof u == "string")
      return u;
    if (t(u))
      return e(u, s) + "";
    if (n(u))
      return i ? i.call(u) : "";
    var o = u + "";
    return o == "0" && 1 / u == -1 / 0 ? "-0" : o;
  }
  return pn = s, pn;
}
var vn, Ks;
function Af() {
  if (Ks) return vn;
  Ks = 1;
  var r = Rf();
  function e(t) {
    return t == null ? "" : r(t);
  }
  return vn = e, vn;
}
var _n, Hs;
function Lu() {
  if (Hs) return _n;
  Hs = 1;
  var r = F(), e = zn(), t = If(), n = Af();
  function a(i, s) {
    return r(i) ? i : e(i, s) ? [i] : t(n(i));
  }
  return _n = a, _n;
}
var yn, Vs;
function Re() {
  if (Vs) return yn;
  Vs = 1;
  var r = Ie();
  function e(t) {
    if (typeof t == "string" || r(t))
      return t;
    var n = t + "";
    return n == "0" && 1 / t == -1 / 0 ? "-0" : n;
  }
  return yn = e, yn;
}
var bn, zs;
function ju() {
  if (zs) return bn;
  zs = 1;
  var r = Lu(), e = Re();
  function t(n, a) {
    a = r(a, n);
    for (var i = 0, s = a.length; n != null && i < s; )
      n = n[e(a[i++])];
    return i && i == s ? n : void 0;
  }
  return bn = t, bn;
}
var gn, Us;
function Tf() {
  if (Us) return gn;
  Us = 1;
  var r = ju();
  function e(t, n, a) {
    var i = t == null ? void 0 : r(t, n);
    return i === void 0 ? a : i;
  }
  return gn = e, gn;
}
var mn, Ws;
function Cf() {
  if (Ws) return mn;
  Ws = 1;
  function r(e, t) {
    return e != null && t in Object(e);
  }
  return mn = r, mn;
}
var qn, Js;
function Sf() {
  if (Js) return qn;
  Js = 1;
  var r = Lu(), e = kn(), t = F(), n = _u(), a = Bn(), i = Re();
  function s(u, o, c) {
    o = r(o, u);
    for (var l = -1, f = o.length, h = !1; ++l < f; ) {
      var d = i(o[l]);
      if (!(h = u != null && c(u, d)))
        break;
      u = u[d];
    }
    return h || ++l != f ? h : (f = u == null ? 0 : u.length, !!f && a(f) && n(d, f) && (t(u) || e(u)));
  }
  return qn = s, qn;
}
var In, Xs;
function Of() {
  if (Xs) return In;
  Xs = 1;
  var r = Cf(), e = Sf();
  function t(n, a) {
    return n != null && e(n, a, r);
  }
  return In = t, In;
}
var Rn, Qs;
function wf() {
  if (Qs) return Rn;
  Qs = 1;
  var r = Eu(), e = Tf(), t = Of(), n = zn(), a = Fu(), i = Mu(), s = Re(), u = 1, o = 2;
  function c(l, f) {
    return n(l) && a(f) ? i(s(l), f) : function(h) {
      var d = e(h, l);
      return d === void 0 && d === f ? t(h, l) : r(f, d, u | o);
    };
  }
  return Rn = c, Rn;
}
var An, Ys;
function xf() {
  if (Ys) return An;
  Ys = 1;
  function r(e) {
    return e;
  }
  return An = r, An;
}
var Tn, Zs;
function Pf() {
  if (Zs) return Tn;
  Zs = 1;
  function r(e) {
    return function(t) {
      return t?.[e];
    };
  }
  return Tn = r, Tn;
}
var Cn, eu;
function Ef() {
  if (eu) return Cn;
  eu = 1;
  var r = ju();
  function e(t) {
    return function(n) {
      return r(n, t);
    };
  }
  return Cn = e, Cn;
}
var Sn, ru;
function Ff() {
  if (ru) return Sn;
  ru = 1;
  var r = Pf(), e = Ef(), t = zn(), n = Re();
  function a(i) {
    return t(i) ? r(n(i)) : e(i);
  }
  return Sn = a, Sn;
}
var On, tu;
function Du() {
  if (tu) return On;
  tu = 1;
  var r = gf(), e = wf(), t = xf(), n = F(), a = Ff();
  function i(s) {
    return typeof s == "function" ? s : s == null ? t : typeof s == "object" ? n(s) ? e(s[0], s[1]) : r(s) : a(s);
  }
  return On = i, On;
}
var wn, nu;
function Mf() {
  if (nu) return wn;
  nu = 1;
  var r = "Expected a function";
  function e(t) {
    if (typeof t != "function")
      throw new TypeError(r);
    return function() {
      var n = arguments;
      switch (n.length) {
        case 0:
          return !t.call(this);
        case 1:
          return !t.call(this, n[0]);
        case 2:
          return !t.call(this, n[0], n[1]);
        case 3:
          return !t.call(this, n[0], n[1], n[2]);
      }
      return !t.apply(this, n);
    };
  }
  return wn = e, wn;
}
var xn, au;
function Lf() {
  if (au) return xn;
  au = 1;
  var r = mu(), e = sf(), t = Du(), n = F(), a = Mf();
  function i(s, u) {
    var o = n(s) ? r : e;
    return o(s, a(t(u, 3)));
  }
  return xn = i, xn;
}
var jf = Lf();
const Df = /* @__PURE__ */ Q(jf);
var Pn, iu;
function kf() {
  if (iu) return Pn;
  iu = 1;
  var r = Array.prototype, e = r.reverse;
  function t(n) {
    return n == null ? n : e.call(n);
  }
  return Pn = t, Pn;
}
var Bf = kf();
const Nf = /* @__PURE__ */ Q(Bf);
var En, su;
function $f() {
  if (su) return En;
  su = 1;
  var r = Ou(), e = Du(), t = wu(), n = Math.max;
  function a(i, s, u) {
    var o = i == null ? 0 : i.length;
    if (!o)
      return -1;
    var c = u == null ? 0 : t(u);
    return c < 0 && (c = n(o + c, 0)), r(i, e(s, 3), c);
  }
  return En = a, En;
}
var Gf = $f();
const uu = /* @__PURE__ */ Q(Gf), de = -1;
function ou(r) {
  return r.replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function Kf(r) {
  return r.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
const Hf = {
  name: "VueTypeaheadBootstrapList",
  components: {
    VueTypeaheadBootstrapListItem: So
  },
  props: {
    data: {
      type: Array,
      required: !0,
      validator: (r) => r instanceof Array
    },
    query: {
      type: String,
      default: ""
    },
    vbtUniqueId: {
      type: Number,
      required: !0
    },
    backgroundVariant: {
      type: String
    },
    backgroundVariantResolver: {
      type: Function,
      default: (r) => null,
      validator: (r) => r instanceof Function
    },
    disableSort: {
      type: Boolean
    },
    textVariant: {
      type: String
    },
    maxMatches: {
      type: Number,
      default: 10
    },
    minMatchingChars: {
      type: Number,
      default: 2
    },
    disabledValues: {
      type: Array,
      default: () => []
    },
    showOnFocus: {
      type: Boolean,
      default: !1
    },
    showAllResults: {
      type: Boolean,
      default: !1
    },
    highlightClass: {
      type: String,
      default: "vbt-matched-text"
    }
  },
  created() {
    this.$parent.$on("input", this.resetActiveListItem), this.$parent.$on("keyup", this.handleParentInputKeyup);
  },
  data() {
    return {
      activeListItem: -1
    };
  },
  computed: {
    highlight() {
      return (r) => {
        if (r = ou(r), this.query.length === 0)
          return r;
        const e = new RegExp(this.escapedQuery, "gi");
        return r.replace(e, `<span class='${this.highlightClass}'>$&</span>`);
      };
    },
    escapedQuery() {
      return Kf(ou(this.query));
    },
    actionableItems() {
      return Df(this.matchedItems, (r) => this.isDisabledItem(r));
    },
    matchedItems() {
      if (!this.showOnFocus && (Zc(this.query) || this.query.length < this.minMatchingChars))
        return [];
      const r = new RegExp(this.showAllResults ? "" : this.escapedQuery, "gi");
      return this.data.filter((e) => e.text.match(r) !== null).sort((e, t) => {
        if (this.disableSort) return 0;
        const n = e.text.indexOf(e.text.match(r)[0]), a = t.text.indexOf(t.text.match(r)[0]);
        return n < a ? -1 : n > a ? 1 : 0;
      }).slice(0, this.maxMatches);
    }
  },
  methods: {
    handleParentInputKeyup(r) {
      switch (r.keyCode) {
        case 40:
          this.selectNextListItem();
          break;
        case 38:
          this.selectPreviousListItem();
          break;
        case 13:
          this.hitActiveListItem();
          break;
      }
    },
    handleHit(r, e) {
      this.$emit("hit", r), e.preventDefault();
    },
    hitActiveListItem() {
      this.activeListItem < 0 && this.selectNextListItem(), this.activeListItem >= 0 && this.$emit("hit", this.matchedItems[this.activeListItem]);
    },
    isDisabledItem(r) {
      return Xc(this.disabledValues, r.text);
    },
    isListItemActive(r) {
      return this.activeListItem === r;
    },
    resetActiveListItem() {
      this.activeListItem = -1;
    },
    findIndexForNextActiveItem(r, e) {
      r || (r = this.matchedItems), e === void 0 && (e = this.activeListItem);
      let t = uu(
        r,
        function(n) {
          return !this.isDisabledItem(n);
        }.bind(this),
        e + 1
      );
      return t === de && (t = uu(
        r,
        function(n) {
          return !this.isDisabledItem(n);
        }.bind(this)
      )), t;
    },
    selectNextListItem() {
      if (this.actionableItems.length <= 0)
        return this.activeListItem = de, !0;
      this.activeListItem = this.findIndexForNextActiveItem();
    },
    selectPreviousListItem() {
      if (this.actionableItems.length <= 0)
        return this.activeListItem = de, !0;
      this.activeListItem === 0 && (this.activeListItem = de);
      let r = Nf(Dc(this.matchedItems)), e = this.matchedItems.length - 1 - this.activeListItem, t = this.findIndexForNextActiveItem(r, e);
      this.activeListItem = this.matchedItems.length - 1 - t;
    }
  },
  watch: {
    activeListItem(r, e) {
      if (!this.$parent.autoClose && this.$parent.isFocused === !1 && (this.$parent.isFocused = !0), r >= 0) {
        const t = this.$refs.suggestionList, n = t.children[this.activeListItem], a = t.clientHeight, i = n.clientHeight, s = Math.floor(
          a / (i + 20)
        );
        r >= s ? t.scrollTop = i * this.activeListItem : t.scrollTop = 0, n.focus();
      }
    }
  }
};
var Vf = function() {
  var e = this, t = e._self._c;
  return t("div", { ref: "suggestionList", staticClass: "list-group shadow" }, e._l(e.matchedItems, function(n, a) {
    return t("vue-typeahead-bootstrap-list-item", e._g({ key: a, attrs: { active: e.isListItemActive(a), id: e.isListItemActive(a) ? `selected-option-${e.vbtUniqueId}` : !1, data: n.data, "html-text": e.highlight(n.text), role: "option", "aria-selected": e.isListItemActive(a) ? "true" : "false", "screen-reader-text": n.screenReaderText ? n.screenReaderText : n.text, disabled: e.isDisabledItem(n), "background-variant": e.backgroundVariant, "background-variant-resolver": e.backgroundVariantResolver, "text-variant": e.textVariant }, nativeOn: { click: function(i) {
      return e.handleHit(n, i);
    } }, scopedSlots: e._u([{ key: "suggestion", fn: function({ data: i, htmlText: s }) {
      return e.$scopedSlots.suggestion ? [e._t("suggestion", null, null, { data: i, htmlText: s })] : void 0;
    } }], null, !0) }, e.$listeners));
  }), 1);
}, zf = [], Uf = /* @__PURE__ */ M(
  Hf,
  Vf,
  zf,
  !1,
  null,
  null
);
const Wf = Uf.exports;
var ku = (function() {
  if (typeof Map < "u")
    return Map;
  function r(e, t) {
    var n = -1;
    return e.some(function(a, i) {
      return a[0] === t ? (n = i, !0) : !1;
    }), n;
  }
  return (
    /** @class */
    (function() {
      function e() {
        this.__entries__ = [];
      }
      return Object.defineProperty(e.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.get = function(t) {
        var n = r(this.__entries__, t), a = this.__entries__[n];
        return a && a[1];
      }, e.prototype.set = function(t, n) {
        var a = r(this.__entries__, t);
        ~a ? this.__entries__[a][1] = n : this.__entries__.push([t, n]);
      }, e.prototype.delete = function(t) {
        var n = this.__entries__, a = r(n, t);
        ~a && n.splice(a, 1);
      }, e.prototype.has = function(t) {
        return !!~r(this.__entries__, t);
      }, e.prototype.clear = function() {
        this.__entries__.splice(0);
      }, e.prototype.forEach = function(t, n) {
        n === void 0 && (n = null);
        for (var a = 0, i = this.__entries__; a < i.length; a++) {
          var s = i[a];
          t.call(n, s[1], s[0]);
        }
      }, e;
    })()
  );
})(), Fn = typeof window < "u" && typeof document < "u" && window.document === document, he = (function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
})(), Jf = (function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(he) : function(r) {
    return setTimeout(function() {
      return r(Date.now());
    }, 1e3 / 60);
  };
})(), Xf = 2;
function Qf(r, e) {
  var t = !1, n = !1, a = 0;
  function i() {
    t && (t = !1, r()), n && u();
  }
  function s() {
    Jf(i);
  }
  function u() {
    var o = Date.now();
    if (t) {
      if (o - a < Xf)
        return;
      n = !0;
    } else
      t = !0, n = !1, setTimeout(s, e);
    a = o;
  }
  return u;
}
var Yf = 20, Zf = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], el = typeof MutationObserver < "u", rl = (
  /** @class */
  (function() {
    function r() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = Qf(this.refresh.bind(this), Yf);
    }
    return r.prototype.addObserver = function(e) {
      ~this.observers_.indexOf(e) || this.observers_.push(e), this.connected_ || this.connect_();
    }, r.prototype.removeObserver = function(e) {
      var t = this.observers_, n = t.indexOf(e);
      ~n && t.splice(n, 1), !t.length && this.connected_ && this.disconnect_();
    }, r.prototype.refresh = function() {
      var e = this.updateObservers_();
      e && this.refresh();
    }, r.prototype.updateObservers_ = function() {
      var e = this.observers_.filter(function(t) {
        return t.gatherActive(), t.hasActive();
      });
      return e.forEach(function(t) {
        return t.broadcastActive();
      }), e.length > 0;
    }, r.prototype.connect_ = function() {
      !Fn || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), el ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, r.prototype.disconnect_ = function() {
      !Fn || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, r.prototype.onTransitionEnd_ = function(e) {
      var t = e.propertyName, n = t === void 0 ? "" : t, a = Zf.some(function(i) {
        return !!~n.indexOf(i);
      });
      a && this.refresh();
    }, r.getInstance = function() {
      return this.instance_ || (this.instance_ = new r()), this.instance_;
    }, r.instance_ = null, r;
  })()
), Bu = (function(r, e) {
  for (var t = 0, n = Object.keys(e); t < n.length; t++) {
    var a = n[t];
    Object.defineProperty(r, a, {
      value: e[a],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return r;
}), X = (function(r) {
  var e = r && r.ownerDocument && r.ownerDocument.defaultView;
  return e || he;
}), Nu = Ae(0, 0, 0, 0);
function pe(r) {
  return parseFloat(r) || 0;
}
function cu(r) {
  for (var e = [], t = 1; t < arguments.length; t++)
    e[t - 1] = arguments[t];
  return e.reduce(function(n, a) {
    var i = r["border-" + a + "-width"];
    return n + pe(i);
  }, 0);
}
function tl(r) {
  for (var e = ["top", "right", "bottom", "left"], t = {}, n = 0, a = e; n < a.length; n++) {
    var i = a[n], s = r["padding-" + i];
    t[i] = pe(s);
  }
  return t;
}
function nl(r) {
  var e = r.getBBox();
  return Ae(0, 0, e.width, e.height);
}
function al(r) {
  var e = r.clientWidth, t = r.clientHeight;
  if (!e && !t)
    return Nu;
  var n = X(r).getComputedStyle(r), a = tl(n), i = a.left + a.right, s = a.top + a.bottom, u = pe(n.width), o = pe(n.height);
  if (n.boxSizing === "border-box" && (Math.round(u + i) !== e && (u -= cu(n, "left", "right") + i), Math.round(o + s) !== t && (o -= cu(n, "top", "bottom") + s)), !sl(r)) {
    var c = Math.round(u + i) - e, l = Math.round(o + s) - t;
    Math.abs(c) !== 1 && (u -= c), Math.abs(l) !== 1 && (o -= l);
  }
  return Ae(a.left, a.top, u, o);
}
var il = /* @__PURE__ */ (function() {
  return typeof SVGGraphicsElement < "u" ? function(r) {
    return r instanceof X(r).SVGGraphicsElement;
  } : function(r) {
    return r instanceof X(r).SVGElement && typeof r.getBBox == "function";
  };
})();
function sl(r) {
  return r === X(r).document.documentElement;
}
function ul(r) {
  return Fn ? il(r) ? nl(r) : al(r) : Nu;
}
function ol(r) {
  var e = r.x, t = r.y, n = r.width, a = r.height, i = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, s = Object.create(i.prototype);
  return Bu(s, {
    x: e,
    y: t,
    width: n,
    height: a,
    top: t,
    right: e + n,
    bottom: a + t,
    left: e
  }), s;
}
function Ae(r, e, t, n) {
  return { x: r, y: e, width: t, height: n };
}
var cl = (
  /** @class */
  (function() {
    function r(e) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = Ae(0, 0, 0, 0), this.target = e;
    }
    return r.prototype.isActive = function() {
      var e = ul(this.target);
      return this.contentRect_ = e, e.width !== this.broadcastWidth || e.height !== this.broadcastHeight;
    }, r.prototype.broadcastRect = function() {
      var e = this.contentRect_;
      return this.broadcastWidth = e.width, this.broadcastHeight = e.height, e;
    }, r;
  })()
), fl = (
  /** @class */
  /* @__PURE__ */ (function() {
    function r(e, t) {
      var n = ol(t);
      Bu(this, { target: e, contentRect: n });
    }
    return r;
  })()
), ll = (
  /** @class */
  (function() {
    function r(e, t, n) {
      if (this.activeObservations_ = [], this.observations_ = new ku(), typeof e != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = e, this.controller_ = t, this.callbackCtx_ = n;
    }
    return r.prototype.observe = function(e) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(e instanceof X(e).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var t = this.observations_;
        t.has(e) || (t.set(e, new cl(e)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, r.prototype.unobserve = function(e) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(e instanceof X(e).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var t = this.observations_;
        t.has(e) && (t.delete(e), t.size || this.controller_.removeObserver(this));
      }
    }, r.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, r.prototype.gatherActive = function() {
      var e = this;
      this.clearActive(), this.observations_.forEach(function(t) {
        t.isActive() && e.activeObservations_.push(t);
      });
    }, r.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var e = this.callbackCtx_, t = this.activeObservations_.map(function(n) {
          return new fl(n.target, n.broadcastRect());
        });
        this.callback_.call(e, t, e), this.clearActive();
      }
    }, r.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, r.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, r;
  })()
), $u = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new ku(), Gu = (
  /** @class */
  /* @__PURE__ */ (function() {
    function r(e) {
      if (!(this instanceof r))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var t = rl.getInstance(), n = new ll(e, t, this);
      $u.set(this, n);
    }
    return r;
  })()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(r) {
  Gu.prototype[r] = function() {
    var e;
    return (e = $u.get(this))[r].apply(e, arguments);
  };
});
var dl = (function() {
  return typeof he.ResizeObserver < "u" ? he.ResizeObserver : Gu;
})();
const hl = {
  name: "VueTypeaheadBootstrap",
  components: {
    VueTypeaheadBootstrapList: Wf
  },
  props: {
    ariaLabelledBy: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null,
      validator: (r) => ["lg", "md", "sm"].indexOf(r) > -1
    },
    value: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    data: {
      type: Array,
      required: !0,
      validator: (r) => r instanceof Array
    },
    serializer: {
      type: Function,
      default: (r) => r,
      validator: (r) => r instanceof Function
    },
    // Don't call this method, use _screenReaderTextSerializer()
    // Using _screenReaderTextSerializer allows for defaulting based on .serializer
    screenReaderTextSerializer: {
      type: Function,
      validator: (r) => r instanceof Function
    },
    backgroundVariant: String,
    backgroundVariantResolver: {
      type: Function,
      default: (r) => r,
      validator: (r) => r instanceof Function
    },
    disabledValues: {
      type: Array,
      default: () => []
    },
    textVariant: String,
    inputClass: {
      type: String,
      default: ""
    },
    inputName: {
      type: String,
      default: void 0
    },
    maxMatches: {
      type: Number,
      default: 10
    },
    minMatchingChars: {
      type: Number,
      default: 2
    },
    disableSort: {
      type: Boolean,
      default: !1
    },
    showOnFocus: {
      type: Boolean,
      default: !1
    },
    showAllResults: {
      type: Boolean,
      default: !1
    },
    autoClose: {
      type: Boolean,
      default: !0
    },
    ieCloseFix: {
      type: Boolean,
      default: !0
    },
    placeholder: String,
    prepend: String,
    append: String,
    highlightClass: String
  },
  computed: {
    id() {
      return Math.floor(Math.random() * 1e5);
    },
    inputGroupClasses() {
      return this.size ? `input-group input-group-${this.size}` : "input-group";
    },
    formattedData() {
      return this.data instanceof Array ? this.data.map((r, e) => ({
        id: e,
        data: r,
        screenReaderText: this._screenReaderTextSerializer(r),
        text: this.serializer(r)
      })) : [];
    }
  },
  methods: {
    _screenReaderTextSerializer(r) {
      return typeof r == "object" && !Array.isArray(r) && r !== null ? this.screenReaderTextSerializer ? this.screenReaderTextSerializer(r) : this.serializer(r) : r;
    },
    resizeList(r) {
      const e = r.getBoundingClientRect(), t = this.$refs.list.$el.style;
      if (t.width = e.width + "px", this.$refs.prependDiv) {
        const n = this.$refs.prependDiv.getBoundingClientRect();
        t.marginLeft = n.width + "px";
      }
    },
    handleHit(r) {
      typeof this.value < "u" && this.$emit("input", r.text), this.inputValue = r.text, this.$emit("hit", r.data), this.autoClose && (this.$refs.input.blur(), this.isFocused = !1);
    },
    handleChildBlur() {
      this.$refs.input.focus(), this.isFocused = !1;
    },
    runFocusOut(r) {
      r && r.classList.contains("vbst-item") || (this.$emit("blur"), this.isFocused = !1);
    },
    handleFocusOut(r) {
      const e = r.relatedTarget;
      navigator.userAgent.match(/Trident.*rv:11\./) && this.ieCloseFix ? setTimeout(() => {
        this.runFocusOut(e);
      }, 300) : this.runFocusOut(e);
    },
    handleInput(r) {
      this.isFocused = !0, this.inputValue = r, typeof this.value < "u" && this.$emit("input", r);
    },
    handleEsc(r) {
      r === "" ? (this.$refs.input.blur(), this.isFocused = !1) : this.inputValue = "";
    }
  },
  data() {
    return {
      isFocused: !1,
      inputValue: this.value || ""
    };
  },
  mounted() {
    this.$_ro = new dl((r) => {
      this.resizeList(this.$refs.input);
    }), this.$_ro.observe(this.$refs.input), this.$_ro.observe(this.$refs.list.$el);
  },
  beforeDestroy() {
    this.$_ro.disconnect();
  },
  watch: {
    value: function(r) {
      this.inputValue = r;
    }
  }
};
var pl = function() {
  var e = this, t = e._self._c;
  return t("div", { attrs: { id: `typeahead-${e.id}`, role: "combobox", "aria-haspopup": "listbox", "aria-owns": `result-list-${e.id}`, "aria-expanded": e.isFocused && e.data.length > 0 ? "true" : "false" } }, [t("div", { class: e.inputGroupClasses }, [e.$slots.prepend || e.prepend ? t("div", { ref: "prependDiv", staticClass: "input-group-prepend" }, [e._t("prepend", function() {
    return [t("span", { staticClass: "input-group-text" }, [e._v(e._s(e.prepend))])];
  })], 2) : e._e(), t("input", { ref: "input", class: `form-control ${e.inputClass}`, attrs: { id: `typeahead-input-${e.id}`, type: "text", role: "searchbox", "aria-labelledby": e.ariaLabelledBy, "aria-multiline": "false", "aria-autocomplete": "list", "aria-controls": `result-list-${e.id}`, "aria-activedescendant": `selected-option-${e.id}`, name: e.inputName, placeholder: e.placeholder, "aria-label": e.ariaLabelledBy ? !1 : e.placeholder, disabled: e.disabled }, domProps: { value: e.inputValue }, on: { focus: function(n) {
    e.isFocused = !0;
  }, blur: e.handleFocusOut, input: function(n) {
    return e.handleInput(n.target.value);
  }, keydown: function(n) {
    return !n.type.indexOf("key") && e._k(n.keyCode, "esc", 27, n.key, ["Esc", "Escape"]) ? null : e.handleEsc(n.target.value);
  }, keyup: function(n) {
    return e.$emit("keyup", n);
  } } }), e.$slots.append || e.append ? t("div", { staticClass: "input-group-append" }, [e._t("append", function() {
    return [t("span", { staticClass: "input-group-text" }, [e._v(e._s(e.append))])];
  })], 2) : e._e()]), t("vue-typeahead-bootstrap-list", { directives: [{ name: "show", rawName: "v-show", value: e.isFocused && e.data.length > 0, expression: "isFocused && data.length > 0" }], ref: "list", staticClass: "vbt-autcomplete-list", attrs: { id: `result-list-${e.id}`, query: e.inputValue, data: e.formattedData, "background-variant": e.backgroundVariant, "background-variant-resolver": e.backgroundVariantResolver, "text-variant": e.textVariant, maxMatches: e.maxMatches, minMatchingChars: e.minMatchingChars, disableSort: e.disableSort, showOnFocus: e.showOnFocus, showAllResults: e.showAllResults, highlightClass: e.highlightClass, disabledValues: e.disabledValues, vbtUniqueId: e.id, role: "listbox" }, on: { hit: e.handleHit, listItemBlur: e.handleChildBlur }, scopedSlots: e._u([e._l(e.$scopedSlots, function(n, a) {
    return { key: a, fn: function({ data: i, htmlText: s }) {
      return [e._t(a, null, null, { data: i, htmlText: s })];
    } };
  })], null, !0) })], 1);
}, vl = [], _l = /* @__PURE__ */ M(
  hl,
  pl,
  vl,
  !1,
  null,
  "9f0c6eb8"
);
const yl = _l.exports, bl = $({
  name: "CTypeahead",
  components: { "b-typeahead": yl },
  props: {
    service: {
      type: Function,
      default: void 0
    },
    itemList: {
      type: Array,
      default: () => J
    },
    adapter: {
      type: Function,
      default: void 0
    },
    placeholder: {
      type: String,
      default: void 0
    },
    state: {
      type: Boolean,
      default: null
    },
    value: {
      type: Object,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      items: J,
      dirty: !1,
      tilt: !0
    };
  },
  computed: {
    inputClass() {
      return this.state === !0 ? "is-valid" : this.state === !1 ? "is-invalid" : void 0;
    },
    inputValue() {
      return this.value ? this.adapter ? this.adapter(this.value) : this.value : this.tilt ? void 0 : N;
    }
  },
  watch: {
    itemList(r) {
      this.items = r;
    }
  },
  methods: {
    onKeydown(r) {
      !this.dirty && (r.key.length === 1 || r.key === "Backspace" || r.key === "Delete" || r.key === "Escape") && (this.dirty = !0);
    },
    async onInput(r) {
      this.service ? this.items = await this.service(r.target.value) ?? J : this.$emit("pattern-changed", r.target.value);
    },
    onHit(r) {
      this.dirty = !1, this.$emit("input", r);
    },
    onBlur() {
      this.items = J, this.dirty && (this.tilt = !this.tilt, this.$emit("input", void 0));
    }
  }
});
var gl = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("b-typeahead", { staticClass: "c-typeahead", attrs: { data: e.items, disabled: e.disabled, placeholder: e.placeholder, serializer: e.adapter, "input-class": e.inputClass, value: e.inputValue }, on: { hit: e.onHit, blur: e.onBlur }, nativeOn: { keydown: function(n) {
    return n.stopPropagation(), e.onKeydown.apply(null, arguments);
  }, input: function(n) {
    return e.onInput.apply(null, arguments);
  } } });
}, ml = [], ql = /* @__PURE__ */ M(
  bl,
  gl,
  ml,
  !1,
  null,
  null
);
const Gl = ql.exports, Il = $({
  name: "CNav",
  props: {
    items: {
      type: Array,
      required: !0
    },
    selectedItem: {
      type: Object,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    isFunction: fu,
    onNavItemClick(r) {
      this.$emit("selected-item", r);
    }
  }
});
var Rl = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("b-nav", { staticClass: "c-nav", attrs: { vertical: "" } }, [e._l(e.items, function(n, a) {
    return [n.type === "groupTitle" ? t("b-nav-text", { key: "g" + a, staticClass: "navbar-text--group-title" }, [e._v(e._s(n.label))]) : n.type === "separator" ? t("b-nav-text", { key: "s" + a, staticClass: "navbar-text--separator" }, [t("hr")]) : t("b-nav-item", { key: "i" + a, attrs: { active: n.target && n.target === e.selectedItem?.target, disabled: e.disabled || (e.isFunction(n.disabled) ? n.disabled(n) : n.disabled) }, on: { click: function(i) {
      return i.stopPropagation(), e.onNavItemClick(n);
    } } }, [t("b-icon", { attrs: { icon: n.icon } }), e._v(e._s(n.label) + " ")], 1)];
  })], 2);
}, Al = [], Tl = /* @__PURE__ */ M(
  Il,
  Rl,
  Al,
  !1,
  null,
  null
);
const Kl = Tl.exports, Cl = $({
  name: "CQuicktable",
  props: {
    columns: {
      type: Array,
      default: void 0
    },
    rows: {
      type: [Function, Array],
      default: void 0
    },
    activeRow: {
      type: Object,
      default: void 0
    },
    rowState: {
      type: Function,
      default: void 0
    },
    stickyHeight: {
      type: [String, Boolean],
      default: "20.6rem"
    },
    perPage: {
      type: [String, Number],
      default: 0
    },
    currentPage: {
      type: Number,
      default: void 0
    },
    busy: { type: Boolean },
    emptyMessage: {
      type: String,
      default: "No hay registros para mostrar"
    }
  },
  emits: ["action"],
  methods: {
    getSlotName(r) {
      return `cell(${r?.key ?? "empty"})`;
    },
    getRowActions(r, e) {
      return r.actions(e);
    },
    getRowCssClass(r) {
      const e = r && this.activeRow && (r === this.activeRow || r.id === this.activeRow.id), t = this.rowState?.(r);
      if (!ho(t))
        return e ? "table-primary" : void 0;
      const n = [];
      return e && n.push("table-primary"), n.push(t ? "is-valid" : "is-invalid"), n;
    },
    onRowActionClick(r, e) {
      this.$emit("action", r, e);
    },
    update() {
      this.$refs.table.refresh();
    }
  }
});
var Sl = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("b-table", { ref: "table", staticClass: "c-quicktable", attrs: { busy: e.busy, "current-page": e.currentPage, fields: e.columns, items: e.rows, "tbody-tr-class": e.getRowCssClass, fixed: "", hover: "", "per-page": e.perPage, "primary-key": "id", "show-empty": "", "sticky-header": e.stickyHeight, striped: "" }, scopedSlots: e._u([{ key: "table-busy", fn: function() {
    return [t("b-spinner", { attrs: { label: "Cargando...", variant: "primary" } })];
  }, proxy: !0 }, { key: "empty", fn: function() {
    return [t("div", [e._v(e._s(e.emptyMessage))])];
  }, proxy: !0 }, { key: "table-colgroup", fn: function({ fields: n }) {
    return e._l(n, function(a) {
      return t("col", { key: a.key, class: a.class ? `col-${a.class}` : void 0 });
    });
  } }, { key: "head()", fn: function({ label: n, field: a }) {
    return [t("span", { directives: [{ name: "b-tooltip", rawName: "v-b-tooltip.hover", modifiers: { hover: !0 } }], attrs: { title: a.tooltip } }, [e._v(e._s(n))])];
  } }, e._l(e.columns, function(n) {
    return { key: e.getSlotName(n), fn: function({ item: a, index: i, field: s, unformatted: u, value: o, detailsShowing: c, rowSelected: l }) {
      return [e._t(e.getSlotName(n), function() {
        return [s.actions ? e._l(e.getRowActions(s, a), function(f, h) {
          return t("b-button", { directives: [{ name: "b-tooltip", rawName: "v-b-tooltip.hover", modifiers: { hover: !0 } }], key: h, attrs: { size: "sm", title: f.tooltip, variant: f.variant || (f.active ? "primary" : "outline-secondary") }, on: { click: function(d) {
            return e.onRowActionClick(h, a);
          } } }, [t("b-icon", { attrs: { icon: f.icon } })], 1);
        }) : e._e(), s.rowNumber ? [e._v(e._s(i + 1))] : [e._v(e._s(o))]];
      }, { item: a, index: i, field: s, unformatted: u, value: o, detailsShowing: c, rowSelected: l })];
    } };
  })], null, !0) });
}, Ol = [], wl = /* @__PURE__ */ M(
  Cl,
  Sl,
  Ol,
  !1,
  null,
  null
);
const Hl = wl.exports, xl = $({
  name: "CDialog",
  props: {},
  data() {
    return {
      options: Yn,
      resolve: void 0,
      reject: void 0,
      open: !1
    };
  },
  computed: {
    primaryLabel() {
      return this.options.primaryLabel || "Aceptar";
    },
    secondaryLabel() {
      return this.options.secondaryLabel || "Cancelar";
    }
  },
  methods: {
    show(r) {
      return this.options = r ?? this.options, this.open = !0, new Promise((e, t) => {
        this.resolve = e, this.reject = t;
      });
    },
    reset() {
      this.open = !1, this.options = Yn, this.resolve = void 0, this.reject = void 0;
    },
    onPrimaryClick() {
      this.resolve?.(this.options.payload), this.reset();
    },
    onSecondaryClick() {
      this.reject?.(), this.reset();
    }
  }
});
var Pl = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("b-modal", { ref: "modal", attrs: { title: e.options.title }, scopedSlots: e._u([{ key: "modal-footer", fn: function() {
    return [t("b-button", { attrs: { variant: "primary" }, on: { click: e.onPrimaryClick } }, [e._v(e._s(e.primaryLabel))]), t("b-button", { attrs: { variant: "outline-secondary" }, on: { click: e.onSecondaryClick } }, [e._v(e._s(e.secondaryLabel))])];
  }, proxy: !0 }]), model: { value: e.open, callback: function(n) {
    e.open = n;
  }, expression: "open" } }, [e._t("default", function() {
    return [t("div", [e._v(e._s(e.options.body))])];
  })], 2);
}, El = [], Fl = /* @__PURE__ */ M(
  xl,
  Pl,
  El,
  !1,
  null,
  null
);
const Vl = Fl.exports, Ml = /* @__PURE__ */ $({
  __name: "c_loginform",
  props: {
    busy: {
      type: Boolean,
      default: !1
    },
    userPlaceholder: {
      type: String,
      default: "Ingrese usuario"
    },
    passphrasePlaceholder: {
      type: String,
      default: "Ingrese contraseña"
    },
    loginLabel: {
      type: String,
      default: "Ingresar"
    },
    resetLabel: {
      type: String,
      default: "Limpiar"
    }
  },
  emits: ["login", "reset"],
  setup(r, { expose: e, emit: t }) {
    e({ focusPassphrase: l });
    const n = Ce(), a = Ce(N), i = Ce(N);
    function s(f) {
      f.key === "Escape" && (a.value = N);
    }
    function u(f) {
      f.key === "Escape" && (i.value = N);
    }
    function o() {
      t("login", a.value, i.value);
    }
    function c() {
      a.value = N, i.value = N, t("reset");
    }
    async function l() {
      await co(), n.value?.select();
    }
    return { __sfc: !0, emit: t, passRef: n, userName: a, passphrase: i, onUserNameKeydown: s, onPassphraseKeydown: u, onSubmit: o, onReset: c, focusPassphrase: l };
  }
});
var Ll = function() {
  var e = this, t = e._self._c, n = e._self._setupProxy;
  return t("b-form", { staticClass: "c-loginform", on: { reset: n.onReset, submit: function(a) {
    return a.preventDefault(), n.onSubmit.apply(null, arguments);
  } } }, [t("b-form-group", { attrs: { label: "Usuario" } }, [t("b-input-group", { attrs: { prepend: "🧑" } }, [t("b-form-input", { attrs: { disabled: e.busy, placeholder: e.userPlaceholder, type: "email" }, nativeOn: { keydown: function(a) {
    return a.stopPropagation(), n.onUserNameKeydown(a);
  } }, model: { value: n.userName, callback: function(a) {
    n.userName = a;
  }, expression: "userName" } })], 1)], 1), t("b-form-group", { attrs: { label: "Contraseña" } }, [t("b-input-group", { attrs: { prepend: "🔑" } }, [t("b-form-input", { ref: "passRef", attrs: { disabled: e.busy, placeholder: e.passphrasePlaceholder, type: "password" }, nativeOn: { keydown: function(a) {
    return a.stopPropagation(), n.onPassphraseKeydown(a);
  } }, model: { value: n.passphrase, callback: function(a) {
    n.passphrase = a;
  }, expression: "passphrase" } })], 1)], 1), t("div", { staticClass: "c-loginform__actionbar" }, [t("b-button", { attrs: { disabled: e.busy, type: "submit", variant: "primary" } }, [e._v(e._s(e.loginLabel))]), t("b-button", { attrs: { disabled: e.busy, type: "reset", variant: "outline-secondary" } }, [e._v(e._s(e.resetLabel))])], 1)], 1);
}, jl = [], Dl = /* @__PURE__ */ M(
  Ml,
  Ll,
  jl,
  !1,
  null,
  null
);
const zl = Dl.exports;
export {
  Nl as CDatetime,
  Vl as CDialog,
  zl as CLoginform,
  Kl as CNav,
  Hl as CQuicktable,
  $l as CSelect,
  Gl as CTypeahead
};
//# sourceMappingURL=vue2comps.esm.js.map
